/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssureurPrincipalDto } from './AssureurPrincipalDto';
import {
    AssureurPrincipalDtoFromJSON,
    AssureurPrincipalDtoFromJSONTyped,
    AssureurPrincipalDtoToJSON,
    AssureurPrincipalDtoToJSONTyped,
} from './AssureurPrincipalDto';
import type { CoAssureurDto } from './CoAssureurDto';
import {
    CoAssureurDtoFromJSON,
    CoAssureurDtoFromJSONTyped,
    CoAssureurDtoToJSON,
    CoAssureurDtoToJSONTyped,
} from './CoAssureurDto';
import type { ReAssureurDto } from './ReAssureurDto';
import {
    ReAssureurDtoFromJSON,
    ReAssureurDtoFromJSONTyped,
    ReAssureurDtoToJSON,
    ReAssureurDtoToJSONTyped,
} from './ReAssureurDto';
import type { TarifDto } from './TarifDto';
import {
    TarifDtoFromJSON,
    TarifDtoFromJSONTyped,
    TarifDtoToJSON,
    TarifDtoToJSONTyped,
} from './TarifDto';
import type { BorneDto } from './BorneDto';
import {
    BorneDtoFromJSON,
    BorneDtoFromJSONTyped,
    BorneDtoToJSON,
    BorneDtoToJSONTyped,
} from './BorneDto';
import type { GarantieReferentielDto } from './GarantieReferentielDto';
import {
    GarantieReferentielDtoFromJSON,
    GarantieReferentielDtoFromJSONTyped,
    GarantieReferentielDtoToJSON,
    GarantieReferentielDtoToJSONTyped,
} from './GarantieReferentielDto';

/**
 * Détail d'une garantie du tunnel, alimente le formulaire d'édition.
 * @export
 * @interface GarantieTunnelDetailDto
 */
export interface GarantieTunnelDetailDto {
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    garantieTunnelId?: string | null;
    /**
     * Garantie du référentiel dont dérive cette garantie du tunnel.
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    garantieId?: string | null;
    /**
     * 
     * @type {GarantieReferentielDto}
     * @memberof GarantieTunnelDetailDto
     */
    garantie?: GarantieReferentielDto;
    /**
     * 
     * @type {TarifDto}
     * @memberof GarantieTunnelDetailDto
     */
    tarification?: TarifDto;
    /**
     * 
     * @type {boolean}
     * @memberof GarantieTunnelDetailDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    designation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    descriptionCourte?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    descriptionLongue?: string | null;
    /**
     * Colonne « Franchise » du tableau des garanties des documents : HTML libre avec jetons {{CODE}} des variables du tunnel, résolus par dossier à la génération. Vide = texte par défaut du produit.
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    franchiseDetail?: string | null;
    /**
     * Colonne « Plafond » du tableau des garanties des documents, même mécanique.
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    plafondDetail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelDetailDto
     */
    iconeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GarantieTunnelDetailDto
     */
    ordreAffichage?: number;
    /**
     * 
     * @type {AssureurPrincipalDto}
     * @memberof GarantieTunnelDetailDto
     */
    assureurPrincipal?: AssureurPrincipalDto;
    /**
     * 
     * @type {Array<CoAssureurDto>}
     * @memberof GarantieTunnelDetailDto
     */
    coAssureurs?: Array<CoAssureurDto> | null;
    /**
     * 
     * @type {Array<ReAssureurDto>}
     * @memberof GarantieTunnelDetailDto
     */
    reAssureurs?: Array<ReAssureurDto> | null;
    /**
     * 
     * @type {TarifDto}
     * @memberof GarantieTunnelDetailDto
     */
    taxeProfessionelle?: TarifDto;
    /**
     * 
     * @type {TarifDto}
     * @memberof GarantieTunnelDetailDto
     */
    taxeParticulier?: TarifDto;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof GarantieTunnelDetailDto
     */
    franchises?: Array<BorneDto> | null;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof GarantieTunnelDetailDto
     */
    plafonds?: Array<BorneDto> | null;
}

/**
 * Check if a given object implements the GarantieTunnelDetailDto interface.
 */
export function instanceOfGarantieTunnelDetailDto(value: object): value is GarantieTunnelDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GarantieTunnelDetailDtoFromJSON(json: any): GarantieTunnelDetailDto {
    return GarantieTunnelDetailDtoFromJSONTyped(json, false);
}

export function GarantieTunnelDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieTunnelDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'garantieTunnelId': json['garantieTunnelId'] == null ? undefined : json['garantieTunnelId'],
        'garantieId': json['garantieId'] == null ? undefined : json['garantieId'],
        'garantie': json['garantie'] == null ? undefined : GarantieReferentielDtoFromJSON(json['garantie']),
        'tarification': json['tarification'] == null ? undefined : TarifDtoFromJSON(json['tarification']),
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'descriptionCourte': json['descriptionCourte'] == null ? undefined : json['descriptionCourte'],
        'descriptionLongue': json['descriptionLongue'] == null ? undefined : json['descriptionLongue'],
        'franchiseDetail': json['franchiseDetail'] == null ? undefined : json['franchiseDetail'],
        'plafondDetail': json['plafondDetail'] == null ? undefined : json['plafondDetail'],
        'iconeId': json['iconeId'] == null ? undefined : json['iconeId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
        'assureurPrincipal': json['assureurPrincipal'] == null ? undefined : AssureurPrincipalDtoFromJSON(json['assureurPrincipal']),
        'coAssureurs': json['coAssureurs'] == null ? undefined : ((json['coAssureurs'] as Array<any>).map(CoAssureurDtoFromJSON)),
        'reAssureurs': json['reAssureurs'] == null ? undefined : ((json['reAssureurs'] as Array<any>).map(ReAssureurDtoFromJSON)),
        'taxeProfessionelle': json['taxeProfessionelle'] == null ? undefined : TarifDtoFromJSON(json['taxeProfessionelle']),
        'taxeParticulier': json['taxeParticulier'] == null ? undefined : TarifDtoFromJSON(json['taxeParticulier']),
        'franchises': json['franchises'] == null ? undefined : ((json['franchises'] as Array<any>).map(BorneDtoFromJSON)),
        'plafonds': json['plafonds'] == null ? undefined : ((json['plafonds'] as Array<any>).map(BorneDtoFromJSON)),
    };
}

export function GarantieTunnelDetailDtoToJSON(json: any): GarantieTunnelDetailDto {
    return GarantieTunnelDetailDtoToJSONTyped(json, false);
}

export function GarantieTunnelDetailDtoToJSONTyped(value?: GarantieTunnelDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'garantieTunnelId': value['garantieTunnelId'],
        'garantieId': value['garantieId'],
        'garantie': GarantieReferentielDtoToJSON(value['garantie']),
        'tarification': TarifDtoToJSON(value['tarification']),
        'isRequired': value['isRequired'],
        'designation': value['designation'],
        'descriptionCourte': value['descriptionCourte'],
        'descriptionLongue': value['descriptionLongue'],
        'franchiseDetail': value['franchiseDetail'],
        'plafondDetail': value['plafondDetail'],
        'iconeId': value['iconeId'],
        'ordreAffichage': value['ordreAffichage'],
        'assureurPrincipal': AssureurPrincipalDtoToJSON(value['assureurPrincipal']),
        'coAssureurs': value['coAssureurs'] == null ? undefined : ((value['coAssureurs'] as Array<any>).map(CoAssureurDtoToJSON)),
        'reAssureurs': value['reAssureurs'] == null ? undefined : ((value['reAssureurs'] as Array<any>).map(ReAssureurDtoToJSON)),
        'taxeProfessionelle': TarifDtoToJSON(value['taxeProfessionelle']),
        'taxeParticulier': TarifDtoToJSON(value['taxeParticulier']),
        'franchises': value['franchises'] == null ? undefined : ((value['franchises'] as Array<any>).map(BorneDtoToJSON)),
        'plafonds': value['plafonds'] == null ? undefined : ((value['plafonds'] as Array<any>).map(BorneDtoToJSON)),
    };
}

